import { Link } from 'react-router-dom';

import { PanelSectionHeader } from './PanelSectionHeader';

/** Lo que la sección necesita de una mención sin leer (`core.mentions`). */
export interface MencionSinLeer {
  id: string;
  context_url: string | null;
  source_kind: string;
  created_at: string;
}

/** Bloque «Menciones» de la campanita. Extraído de NotificationBell para no pasar el límite de tamaño. */
export function MentionsSection({
  mentions,
  onActivate,
}: {
  mentions: readonly MencionSinLeer[];
  onActivate: (id: string) => void;
}) {
  if (mentions.length === 0) return null;
  return (
    <div>
      <PanelSectionHeader
        title="Menciones"
        aside={
          <span className="text-err">
            {mentions.length} nueva{mentions.length === 1 ? '' : 's'}
          </span>
        }
      />
      <ul>
        {mentions.slice(0, 6).map((m) => (
          <li
            key={m.id}
            className="hover:bg-surface-hi/40 border-border-dim/40 border-b last:border-0"
          >
            <Link
              to={m.context_url ?? '/chat'}
              onClick={() => onActivate(m.id)}
              className="flex items-center gap-2 px-3.5 py-2 text-caption"
            >
              <span className="text-rose-300 font-mono text-micro">@</span>
              <span className="text-foreground flex-1 truncate">
                Te mencionaron · {m.source_kind === 'message' ? 'chat' : m.source_kind}
              </span>
              <span className="text-fg-dim font-mono text-micro">
                {new Date(m.created_at).toLocaleTimeString('es-AR', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
